var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalTopLeftMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 6.66671L0.959397 5.9596L0.25229 6.66671L0.959397 7.37381L1.6665 6.66671ZM17.4998 7.66671C18.0521 7.66671 18.4998 7.21899 18.4998 6.66671C18.4998 6.11442 18.0521 5.66671 17.4998 5.66671V7.66671ZM4.29273 2.62627L0.959397 5.9596L2.37361 7.37381L5.70694 4.04048L4.29273 2.62627ZM0.959397 7.37381L4.29273 10.7071L5.70694 9.29293L2.37361 5.9596L0.959397 7.37381ZM1.6665 7.66671H17.4998V5.66671H1.6665V7.66671Z",
    fill: "#4D5562"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 13.3333L19.0406 12.6262L19.7477 13.3333L19.0406 14.0404L18.3335 13.3333ZM10.8335 14.3333C10.2812 14.3333 9.8335 13.8856 9.8335 13.3333C9.8335 12.781 10.2812 12.3333 10.8335 12.3333L10.8335 14.3333ZM15.7073 9.29289L19.0406 12.6262L17.6264 14.0404L14.2931 10.7071L15.7073 9.29289ZM19.0406 14.0404L15.7073 17.3738L14.2931 15.9596L17.6264 12.6262L19.0406 14.0404ZM18.3335 14.3333L10.8335 14.3333L10.8335 12.3333L18.3335 12.3333L18.3335 14.3333Z",
    fill: "#4D5562"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalTopLeftMain);
export default __webpack_public_path__ + "static/media/Horizontal_top_left_main.ad304ceb88f756f04190867d89b675a1.svg";
export { ForwardRef as ReactComponent };